// PRC-032: confirmación de acciones destructivas (borrar, archivar, desactivar).
// El color de peligro solo aparece aquí, en el botón que confirma.
import React from 'react';
import { Box, Dialog } from '@mui/material';
import { J } from '../journeyTokens';
import { JourneyButton, JourneyText } from './JourneyBasics';

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  text?: React.ReactNode;
  confirmLabel: string;
  busyLabel?: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, text, confirmLabel, busyLabel, busy, onConfirm, onCancel }) => (
  <Dialog
    open={open}
    onClose={busy ? undefined : onCancel}
    aria-labelledby="confirm-dialog-title"
    PaperProps={{ sx: { bgcolor: J.panel, backgroundImage: 'none', border: `1px solid ${J.border}`, borderRadius: J.radiusCard, maxWidth: 440, width: '100%', p: 3, fontFamily: J.font } }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <JourneyText variant="h3" component="h2" sx={{ m: 0 }}><span id="confirm-dialog-title">{title}</span></JourneyText>
      {text && <JourneyText variant="small">{text}</JourneyText>}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: 1.5, flexWrap: 'wrap' }}>
        <JourneyButton kind="ghost" small autoFocus onClick={onCancel} disabled={busy}>Cancelar</JourneyButton>
        <JourneyButton
          small
          onClick={onConfirm}
          disabled={busy}
          sx={{ bgcolor: J.danger, color: '#1f0a0a', '&:hover': { bgcolor: J.dangerText } }}
        >
          {busy ? (busyLabel ?? `${confirmLabel}…`) : confirmLabel}
        </JourneyButton>
      </Box>
    </Box>
  </Dialog>
);

export default ConfirmDialog;
